import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang:"en",
  },
  mutations: {
    SHOW_MODAL(state, payload) {
      //state[Object.keys(payload)[0]] = Object.values(payload)[0];
      state.modals[payload.modal] = payload.state;
    },
    CHANGE_LANG(state) {
      if(state.lang == "en"){
        state.lang = "ru";
      }else{
        state.lang = "en";
      }
    },
    SET_LANG(state, prop) {
      state.lang = prop;
    },
  },
  actions: {
  },
  modules: {
  }
})
